import { Badge, VisuallyHidden } from '@buffer-mono/popcorn'

import { formatCompactNumber } from '~publish/helpers/numberFormatters'

import styles from './CommentsTabIndicator.module.css'

import type { JSX } from 'react'

type CommentsTabIndicatorProps = {
  /** Unanswered comment count for the current scope (channel or all channels). */
  count: number | null
}

/**
 * The unanswered-comments count shown on the Comments tab. Always a number
 * (comments have no dot mode — that's mentions-only); hidden at 0.
 */
export function CommentsTabIndicator({
  count,
}: CommentsTabIndicatorProps): JSX.Element | null {
  if (count == null || count <= 0) {
    return null
  }

  return (
    <Badge variant="brand" size="small" className={styles.badge}>
      {formatCompactNumber(count, 99)}
      <VisuallyHidden> unanswered comments</VisuallyHidden>
    </Badge>
  )
}
